import http from '../utils/http';
import Plan from '../view-model/plans/Plan';

const getPlans = () =>
    http.get<Plan[]>(`/v2.1/plans`);

const plansService = { getPlans };

export default plansService;
